





















































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import Header from "@/components/Header.vue";
import { GapFilter, User } from "@/store/modules/types";
import { GapSubStatus } from "@/store/modules/enums";
import moment from "moment";

@Component({
  components: {
    Header,
  },
  computed: mapState("auth", ["user"]),
})
export default class Discharges extends Vue {
  user!: User;
  filter: GapFilter = {
    campaignId: "",
    insurerId: "",
    insurerMemberId: "",
    providerList: null,
    providerId: "",
    providerNPI: "",
    measureTypeId: "DSC",
    measureId: "",
    referenceDateFrom: null,
    referenceDateTo: null,
    priorityId: "",
    statusId: "",
    statusList: null,
    excludedStatusList: ["CLD"],
    subStatusId: "",
    subStatusList: null,
    excludedSubStatusList: ["VIS"],
    recordDateFrom: null,
    recordDateTo: null,
    patientFirstName: "",
    patientLastName: "",
    patientInsurerMemberId: "",
    orderBy: "REF_DATE",
    pageNumber: 1,
    rowsPerPage: 100,
  };
  dates: Array<string> = [];
  pageRows = [];
  totalRows = 0;
  totalPatients = 0;
  get title() {
    if (this.pageRows.length) {
      return "Discharges (" + this.pageRows.length + ")";
    } else {
      return "Discharges";
    }
  }
  async getGaps() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "gaps/getUserEnrolledProviderGapList",
        this.filter
      );
      this.totalRows = data.totalRows;
      this.totalPatients = data.totalPatients;
      this.pageRows = data.pageRows.map((row) => {
        row.referenceDate = moment(row.referenceDate).format("YYYY-MM-DD");
        row.active = false;
        return row;
      });
      this.dates = this.pageRows.map((row) => row["referenceDate"]);
      this.dates = [...new Set(this.dates)];
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  showGap(gap) {
    this.$router.push({ name: "Discharge", params: { id: gap.id } });
  }
  getGapsByRefDate(date) {
    return this.pageRows.filter((row) => row["referenceDate"] === date);
  }
  mounted() {
    // if (this.user.providers.length) {
    //   const list = this.user.providers.map(p => p.id);
    //   this.filter.providerList = list;
    // }
    this.getGaps();
  }
}
